import {createAction} from 'redux-actions';

export const GET_DELIVERY_MANAGER_MANIFEST = 'GET_DELIVERY_MANAGER_MANIFEST';
export const SET_DELIVERY_MANAGER_MANIFEST = 'SET_DELIVERY_MANAGER_MANIFEST';
export const RESET_DELIVERY_MANAGER_MANIFEST = 'RESET_DELIVERY_MANAGER_MANIFEST';

export const getDeliveryManagerManifestAction = createAction(GET_DELIVERY_MANAGER_MANIFEST);
export const setDeliveryManagerManifestAction = createAction(SET_DELIVERY_MANAGER_MANIFEST);
export const resetDeliveryManagerManifestAction = createAction(RESET_DELIVERY_MANAGER_MANIFEST);
